exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".index-container-1mCFx {\r\n}\r\n\r\n.index-content-2XZu9{\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  background: #fff;\r\n}\r\n\r\n.index-navWrapper-3SLgn {\r\n  width: 300px;\r\n  background-color: aqua;\r\n}\r\n\r\n.index-wrapper-4tLd6 {\r\n  width: 100%;\r\n  background-color: azure;\r\n}", "", {"version":3,"sources":["E:/dbProject/dbrank_b/src/routes/cms/components/EditComponent/index.css"],"names":[],"mappings":"AAAA;CACC;;AAED;EACE,qBAAc;EAAd,cAAc;EACd,iBAAiB;CAClB;;AAED;EACE,aAAa;EACb,uBAAuB;CACxB;;AAED;EACE,YAAY;EACZ,wBAAwB;CACzB","file":"index.css","sourcesContent":[".container {\r\n}\r\n\r\n.content{\r\n  display: flex;\r\n  background: #fff;\r\n}\r\n\r\n.navWrapper {\r\n  width: 300px;\r\n  background-color: aqua;\r\n}\r\n\r\n.wrapper {\r\n  width: 100%;\r\n  background-color: azure;\r\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "index-container-1mCFx",
	"content": "index-content-2XZu9",
	"navWrapper": "index-navWrapper-3SLgn",
	"wrapper": "index-wrapper-4tLd6"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":true,"modules":true,"localIdentName":"[name]-[local]-[hash:base64:5]","minimize":false,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/routes/cms/components/EditComponent/index.css
// module id = 1734
// module chunks = 1